<template>
  <v-application>
    <v-layout class="ma-2">
      <v-flex v-bind:md8="true">
        <v-card class="mb-3">
          <v-toolbar flat>{{ $t("refund_receipt") }}</v-toolbar>
          <v-card-text>
            <v-layout row px-2>
              <v-flex md6 px-2>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ receipt.receipt_no }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $t("receipt_no") }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-flex>

              <v-flex md6 px-2>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ receipt.service_name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $t("service_name") }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-flex>
            </v-layout>

            <v-layout row px-2>
              <v-flex md6 px-2>
                <v-list-item v-if="receipt.client_name">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ receipt.client_name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $t("client_name") }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-flex>

              <v-flex md6 px-2>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ date_ddmmyy_hhmm(receipt.date) }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $t("date") }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-flex>
            </v-layout>

            <v-data-table
              :items="receipt.sold_item_list"
              :headers="item_headers"
              disable-sort
              hide-default-footer
              :items-per-page="1000"
            >
              <template #[`item.refund`]="{ item }">
                <v-text-field
                  v-model.number="item.refund"
                  type="number"
                  autocomplete="off"
                />
              </template>

              <template #[`item.reminder_refund`]="{ item }">
                <v-text-field
                  v-if="['pcs_item', 'box_item'].includes(item.sold_item_type)"
                  v-model.number="item.reminder_refund"
                  type="number"
                  autocomplete="off"
                />
              </template>

              <template #[`item.returned_reminder`]="{ item }">
                {{
                  ["pcs_item", "box_item"].includes(item.sold_item_type)
                    ? item.returned_reminder
                    : ""
                }}
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="goBack">{{ $t("cancel") }}</v-btn>
            <v-btn
              text
              color="primary"
              @click="confirmRefund"
              :loading="loading_confirm"
              >{{ $t("refund") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-application>
</template>

<script>
import Receipts from "../../mixins/receipts";

export default {
  data: () => ({
    receipt: {},
    loading_confirm: false
  }),
  mixins: [Receipts],
  computed: {
    receipt_id() {
      return this.$route.query.id;
    },
    item_headers() {
      return [
        {
          text: this.$t("name"),
          value: "product_name"
        },
        {
          text: this.$t("price"),
          value: "price",
          width: 80
        },
        {
          text: this.$t("value"),
          value: "value",
          width: 80
        },
        {
          text: this.$t("reset_count"),
          value: "reset_count",
          width: 80
        },
        {
          text: this.$t("reminder"),
          value: "reminder",
          width: 80
        },
        {
          text: this.$t("returned_reminder"),
          value: "returned_reminder",
          width: 80
        },
        {
          text: this.$t("refund"),
          value: "refund",
          width: 70
        },
        {
          text: this.$t("reminder_refund"),
          value: "reminder_refund",
          width: 70
        }
      ];
    },
    receiptNumber() {
      return this.$store.state.receipt_letter;
    }
  },
  watch: {
    "receipt.sold_item_list": {
      deep: true,
      handler() {
        if (!(this.receipt.sold_item_list instanceof Array)) {
          return;
        }
        for (const index in this.receipt.sold_item_list) {
          if (typeof this.receipt.sold_item_list[index].refund == "number") {
            if (
              this.receipt.sold_item_list[index].refund >
              this.receipt.sold_item_list[index].value -
                this.receipt.sold_item_list[index].reset_count
            ) {
              this.receipt.sold_item_list[index].refund =
                this.receipt.sold_item_list[index].value -
                this.receipt.sold_item_list[index].reset_count;
            }
          }

          if (
            this.receipt.sold_item_list[index].sold_item_type == "pcs_item" &&
            typeof this.receipt.sold_item_list[index].reminder_refund ==
              "number"
          ) {
            if (
              this.receipt.sold_item_list[index].reminder_refund >
              this.receipt.sold_item_list[index].count_by_type
            ) {
              this.receipt.sold_item_list[
                index
              ].reminder_refund = this.receipt.sold_item_list[
                index
              ].count_by_type;
            }
          }
        }
      }
    }
  },
  methods: {
    async receiptGetById() {
      const receipt = await this.getReceiptById(this.receipt_id);
      if (!receipt) {
        this.$router.push(`/reports/receipts?id=${this.receipt_id}`);
      }
      this.receipt = receipt;
    },
    async confirmRefund() {
      this.loading_confirm = true;
      const params = {
        cashier_id: this.receipt.cashier_id,
        refund: this.receipt._id,
        refund_number: this.receipt.receipt_no,
        user_id: this.receipt.user_id,
        service: this.receipt.service,
        currency: this.receipt.currency,
        date: new Date().getTime(),
        is_refund: true,
        is_self: true,
        service_value: 0
      };
      const sold_item_list = [];
      let total_price = 0;
      for (const item of this.receipt.sold_item_list) {
        const s = this.$copy(item);
        if (!s.count_by_type) {
          s.count_by_type = 1;
        }

        s.sold_item_id = s._id;
        if (typeof s.refund == "number") {
          s.reset_count = s.reset_count + s.refund;
          s.value = s.refund;
          total_price += s.value * s.price;
        }
        else {
          s.value = 0;
        }

        if (typeof s.reminder_refund == "number") {
          s.reminder = s.reminder_refund;
          if (
            ["pcs_item", "box_item"].includes(s.sold_item_type) &&
            s.reminder_refund
          ) {
            total_price += (s.reminder * s.price) / s.count_by_type;
          }
        }
        else {
          s.reminder = 0;
        }

        if (
          typeof s.refund == "number" ||
          typeof s.reminder_refund == "number"
        ) {
          sold_item_list.push(s);
        }
      }

      if (total_price == 0) {
        this.loading_confirm = false;
        return;
      }

      params.total_price = total_price;
      params.sold_item_list = sold_item_list;

      params.payment = [
        {
          name: "cash",
          value: total_price
        }
      ];
      for (const p of this.receipt.payment) {
        if (p.name == "debt" && p.value > 0) {
          params.payment[0].name = "debt";
        }
      }

      params.receipt_no = `${this.receiptNumber}`;
      const result = await this.refundReceipt(params);
      if (result) {
        this.$router.push("/reports/receipts").catch(() => {});
      }
      this.loading_confirm = false;
    }
  },
  mounted() {
    if (!this.receiptNumber) {
      this.goBack();
    }
    this.receiptGetById();
  }
};
</script>
